import React from 'react';

import { 
  WEAPON_KEYWORD_OPTIONS,
  WeaponKeyword
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  name: string;
  value?: string;
  multiple?: boolean;
  values?: string[];
  weapon_keywords?: WeaponKeyword[] | null;
  allow_all?: boolean;
  allow_none?: boolean;
  allow_any?: boolean;
  onChange: Function;
  disabled?: boolean;
}

const SelectWeaponKeywordBox = ({
  name,
  value = "",
  multiple = false,
  values = [],
  allow_all = false,
  allow_none = false,
  allow_any = false,
  onChange,
  disabled = false
}: Props) => {
  const extra_options: string[] = [];
  if (allow_all) extra_options.push("All");
  if (allow_none) extra_options.push("None");
  if (allow_any) extra_options.push("Any");

  if (multiple) {
    return (
      <SelectStringBox
        options={WEAPON_KEYWORD_OPTIONS}
        extra_options={extra_options}
        multiple
        values={values}
        name={name}
        disabled={disabled}
        onChange={(ids: string[]) => onChange(ids)}
      />
    );
  }

  return (
    <SelectStringBox
      options={WEAPON_KEYWORD_OPTIONS}
      extra_options={extra_options}
      value={value}
      name={name}
      disabled={disabled}
      onChange={(id: string) => onChange(id)}
    />
  );
};

export default SelectWeaponKeywordBox;